import { useState } from "react";
import styled from "styled-components";
import { Modal, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { showErrorNotification } from "src/util/notifications";
import { useMsal } from "@azure/msal-react";

const { Dragger } = Upload;

export const BulkCostUpdateUploadModal = ({
  visible,
  onCancel,
  stateKey,
  importFile,
  params,
  confirmLoading,
  setConfirmLoading,
}: any) => {
  const dispatch = useDispatch();
  const isImportLoading = useSelector(
    (state: any) => state[stateKey]
  ).importLoading;
  const { accounts }: any = useMsal();
  const [open, setOpen] = useState(false);
  const [fileOptions, setFileOptions] = useState();
  const [messageText, setMessageText] = useState("");
  const handleChanges = (options: any) => {
    setMessageText("");
    const format = options?.file?.name?.split(".").pop();
    if (format === "xlsx") {
      if (options?.file?.status !== "removed") {
        setFileOptions(options.file);
        setOpen(true);
      }
    } else {
      showErrorNotification(
        "Incorrect file format. Only .xlsx files are supported.");
    }
  };
  const handleCancel = () => {
    setOpen(false);
    setTimeout(() => onCancel(), 10);
  };
  const handleOk = () => {
    setConfirmLoading(true);
    dispatch(
      importFile({
        file: fileOptions,
        params: params,
        UserName: accounts?.[0]?.username,
      })
    );
    handleCancel();
    setOpen(false);
    setTimeout(() => onCancel(), 10);
    setConfirmLoading(false);
  };
  const handleClose = () => {
    setMessageText("");
    onCancel();
  };
  return (
    <StyledImportModal
      title="Select an excel file(.xlsx) for Bulk Cost Update"
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
    >
      <Dragger
        disabled={isImportLoading}
        accept={".xlsx"}
        maxCount={1}
        beforeUpload={() => false}
        fileList={[]}
        onChange={handleChanges}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        {isImportLoading ? (
          <p className="ant-upload-hint">Processing...</p>
        ) : (
          <>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">Support for a single file only</p>
            {/* <span className={styles["ant-upload-error"]}>{messageText}</span> */}
          </>
        )}
      </Dragger>
      <Modal
        title="Upload Confirmation"
        okText="Ok"
        centered
        style={{ top: 20 }}
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
      >
        <span>
          {"Are you sure you want to perform this bulk cost update?"}
        </span>
      </Modal>
    </StyledImportModal>
  );
};

const StyledImportModal = styled(Modal)`
    .ant-modal-content {
      width: initial;
    }
  `;
